var map = {
	"./angular-locale_af-na.json": [
		39030,
		85250
	],
	"./angular-locale_af-za.json": [
		44130,
		30262
	],
	"./angular-locale_af.json": [
		40572,
		32422
	],
	"./angular-locale_agq-cm.json": [
		81937,
		51191
	],
	"./angular-locale_agq.json": [
		6382,
		69282
	],
	"./angular-locale_ak-gh.json": [
		58633,
		23605
	],
	"./angular-locale_ak.json": [
		34920,
		48637
	],
	"./angular-locale_am-et.json": [
		49389,
		79665
	],
	"./angular-locale_am.json": [
		25377,
		77523
	],
	"./angular-locale_ar-001.json": [
		35078,
		32000
	],
	"./angular-locale_ar-ae.json": [
		83465,
		70245
	],
	"./angular-locale_ar-bh.json": [
		61617,
		53189
	],
	"./angular-locale_ar-dj.json": [
		92181,
		84469
	],
	"./angular-locale_ar-dz.json": [
		95397,
		64389
	],
	"./angular-locale_ar-eg.json": [
		95731,
		47523
	],
	"./angular-locale_ar-eh.json": [
		53142,
		65090
	],
	"./angular-locale_ar-er.json": [
		27932,
		80652
	],
	"./angular-locale_ar-il.json": [
		52990,
		80418
	],
	"./angular-locale_ar-iq.json": [
		59637,
		70753
	],
	"./angular-locale_ar-jo.json": [
		52448,
		82352
	],
	"./angular-locale_ar-km.json": [
		23379,
		74831
	],
	"./angular-locale_ar-kw.json": [
		82069,
		72597
	],
	"./angular-locale_ar-lb.json": [
		101,
		45029
	],
	"./angular-locale_ar-ly.json": [
		24896,
		18764
	],
	"./angular-locale_ar-ma.json": [
		16513,
		149
	],
	"./angular-locale_ar-mr.json": [
		22564,
		80564
	],
	"./angular-locale_ar-om.json": [
		97351,
		96923
	],
	"./angular-locale_ar-ps.json": [
		70134,
		46246
	],
	"./angular-locale_ar-qa.json": [
		31277,
		48089
	],
	"./angular-locale_ar-sa.json": [
		11724,
		85027
	],
	"./angular-locale_ar-sd.json": [
		67568,
		63484
	],
	"./angular-locale_ar-so.json": [
		46565,
		94021
	],
	"./angular-locale_ar-ss.json": [
		59721,
		77025
	],
	"./angular-locale_ar-sy.json": [
		44903,
		97739
	],
	"./angular-locale_ar-td.json": [
		27455,
		46915
	],
	"./angular-locale_ar-tn.json": [
		36817,
		20873
	],
	"./angular-locale_ar-xb.json": [
		45353,
		92849
	],
	"./angular-locale_ar-ye.json": [
		67841,
		37053
	],
	"./angular-locale_ar.json": [
		67824,
		98178
	],
	"./angular-locale_as-in.json": [
		25945,
		71241
	],
	"./angular-locale_as.json": [
		8371,
		92709
	],
	"./angular-locale_asa-tz.json": [
		1879,
		5713
	],
	"./angular-locale_asa.json": [
		38429,
		35622
	],
	"./angular-locale_ast-es.json": [
		90780,
		65326
	],
	"./angular-locale_ast.json": [
		76657,
		12133
	],
	"./angular-locale_az-cyrl-az.json": [
		60407,
		44057
	],
	"./angular-locale_az-cyrl.json": [
		14677,
		70481
	],
	"./angular-locale_az-latn-az.json": [
		97610,
		58752
	],
	"./angular-locale_az-latn.json": [
		62946,
		6738
	],
	"./angular-locale_az.json": [
		21256,
		37962
	],
	"./angular-locale_bas-cm.json": [
		5070,
		95500
	],
	"./angular-locale_bas.json": [
		83971,
		43919
	],
	"./angular-locale_be-by.json": [
		98448,
		58560
	],
	"./angular-locale_be.json": [
		40194,
		79712
	],
	"./angular-locale_bem-zm.json": [
		7321,
		95131
	],
	"./angular-locale_bem.json": [
		72821,
		26717
	],
	"./angular-locale_bez-tz.json": [
		21921,
		55051
	],
	"./angular-locale_bez.json": [
		48740,
		52448
	],
	"./angular-locale_bg-bg.json": [
		28368,
		73332
	],
	"./angular-locale_bg.json": [
		2160,
		22686
	],
	"./angular-locale_bm-ml.json": [
		49376,
		67312
	],
	"./angular-locale_bm.json": [
		2330,
		84696
	],
	"./angular-locale_bn-bd.json": [
		18604,
		23900
	],
	"./angular-locale_bn-in.json": [
		70225,
		56069
	],
	"./angular-locale_bn.json": [
		57003,
		59753
	],
	"./angular-locale_bo-cn.json": [
		93810,
		94782
	],
	"./angular-locale_bo-in.json": [
		95556,
		56016
	],
	"./angular-locale_bo.json": [
		55592,
		77686
	],
	"./angular-locale_br-fr.json": [
		60690,
		21838
	],
	"./angular-locale_br.json": [
		97327,
		62877
	],
	"./angular-locale_brx-in.json": [
		33735,
		23237
	],
	"./angular-locale_brx.json": [
		92033,
		19753
	],
	"./angular-locale_bs-cyrl-ba.json": [
		86969,
		95323
	],
	"./angular-locale_bs-cyrl.json": [
		73617,
		51553
	],
	"./angular-locale_bs-latn-ba.json": [
		11684,
		40682
	],
	"./angular-locale_bs-latn.json": [
		68254,
		50850
	],
	"./angular-locale_bs.json": [
		74908,
		3194
	],
	"./angular-locale_ca-ad.json": [
		75843,
		8579
	],
	"./angular-locale_ca-es-valencia.json": [
		4722,
		85628
	],
	"./angular-locale_ca-es.json": [
		77722,
		43494
	],
	"./angular-locale_ca-fr.json": [
		12498,
		66094
	],
	"./angular-locale_ca-it.json": [
		26251,
		64283
	],
	"./angular-locale_ca.json": [
		35567,
		28541
	],
	"./angular-locale_ce-ru.json": [
		76567,
		20711
	],
	"./angular-locale_ce.json": [
		84483,
		43457
	],
	"./angular-locale_cgg-ug.json": [
		63233,
		57059
	],
	"./angular-locale_cgg.json": [
		35630,
		10354
	],
	"./angular-locale_chr-us.json": [
		45725,
		75239
	],
	"./angular-locale_chr.json": [
		6342,
		62778
	],
	"./angular-locale_ckb-arab-iq.json": [
		82649,
		9733
	],
	"./angular-locale_ckb-arab-ir.json": [
		28140,
		74996
	],
	"./angular-locale_ckb-arab.json": [
		85540,
		55286
	],
	"./angular-locale_ckb-iq.json": [
		64138,
		21516
	],
	"./angular-locale_ckb-ir.json": [
		50408,
		89149
	],
	"./angular-locale_ckb-latn-iq.json": [
		85666,
		33350
	],
	"./angular-locale_ckb-latn.json": [
		57902,
		21027
	],
	"./angular-locale_ckb.json": [
		86201,
		80005
	],
	"./angular-locale_cs-cz.json": [
		1213,
		86673
	],
	"./angular-locale_cs.json": [
		47513,
		28719
	],
	"./angular-locale_cu-ru.json": [
		53991,
		85079
	],
	"./angular-locale_cu.json": [
		79219,
		74897
	],
	"./angular-locale_cy-gb.json": [
		18347,
		41383
	],
	"./angular-locale_cy.json": [
		10519,
		60453
	],
	"./angular-locale_da-dk.json": [
		92186,
		81722
	],
	"./angular-locale_da-gl.json": [
		86444,
		80968
	],
	"./angular-locale_da.json": [
		31264,
		72474
	],
	"./angular-locale_dav-ke.json": [
		98233,
		38771
	],
	"./angular-locale_dav.json": [
		11990,
		99270
	],
	"./angular-locale_de-at.json": [
		58242,
		88934
	],
	"./angular-locale_de-be.json": [
		87385,
		83506
	],
	"./angular-locale_de-ch.json": [
		98000,
		28740
	],
	"./angular-locale_de-de.json": [
		88312,
		67068
	],
	"./angular-locale_de-it.json": [
		18026,
		41982
	],
	"./angular-locale_de-li.json": [
		25620,
		30848
	],
	"./angular-locale_de-lu.json": [
		36112,
		90628
	],
	"./angular-locale_de.json": [
		74716,
		55022
	],
	"./angular-locale_dje-ne.json": [
		35090,
		4480
	],
	"./angular-locale_dje.json": [
		60644,
		48376
	],
	"./angular-locale_dsb-de.json": [
		81656,
		66390
	],
	"./angular-locale_dsb.json": [
		62140,
		51692
	],
	"./angular-locale_dua-cm.json": [
		97682,
		51688
	],
	"./angular-locale_dua.json": [
		49983,
		98339
	],
	"./angular-locale_dyo-sn.json": [
		11633,
		25995
	],
	"./angular-locale_dyo.json": [
		58001,
		33849
	],
	"./angular-locale_dz-bt.json": [
		70974,
		98570
	],
	"./angular-locale_dz.json": [
		45989,
		26727
	],
	"./angular-locale_ebu-ke.json": [
		53166,
		48028
	],
	"./angular-locale_ebu.json": [
		65059,
		81951
	],
	"./angular-locale_ee-gh.json": [
		11475,
		76343
	],
	"./angular-locale_ee-tg.json": [
		40729,
		84537
	],
	"./angular-locale_ee.json": [
		56845,
		1167
	],
	"./angular-locale_el-cy.json": [
		2673,
		32373
	],
	"./angular-locale_el-gr.json": [
		38304,
		24712
	],
	"./angular-locale_el.json": [
		36698,
		79476
	],
	"./angular-locale_en-001.json": [
		65422,
		60832
	],
	"./angular-locale_en-150.json": [
		4847,
		70729
	],
	"./angular-locale_en-ag.json": [
		12359,
		46855
	],
	"./angular-locale_en-ai.json": [
		72829,
		79409
	],
	"./angular-locale_en-as.json": [
		85035,
		9931
	],
	"./angular-locale_en-at.json": [
		46998,
		54258
	],
	"./angular-locale_en-au.json": [
		70993,
		93429
	],
	"./angular-locale_en-bb.json": [
		27703,
		37647
	],
	"./angular-locale_en-be.json": [
		77882,
		80926
	],
	"./angular-locale_en-bi.json": [
		95582,
		77954
	],
	"./angular-locale_en-bm.json": [
		4674,
		52278
	],
	"./angular-locale_en-bs.json": [
		30964,
		69836
	],
	"./angular-locale_en-bw.json": [
		40280,
		46576
	],
	"./angular-locale_en-bz.json": [
		95151,
		30903
	],
	"./angular-locale_en-ca.json": [
		93991,
		24467
	],
	"./angular-locale_en-cc.json": [
		84001,
		18049
	],
	"./angular-locale_en-ch.json": [
		99196,
		87688
	],
	"./angular-locale_en-ck.json": [
		49609,
		55161
	],
	"./angular-locale_en-cm.json": [
		2883,
		96567
	],
	"./angular-locale_en-cx.json": [
		49708,
		8600
	],
	"./angular-locale_en-cy.json": [
		9228,
		72923
	],
	"./angular-locale_en-de.json": [
		37716,
		74128
	],
	"./angular-locale_en-dg.json": [
		94310,
		23118
	],
	"./angular-locale_en-dk.json": [
		65746,
		91954
	],
	"./angular-locale_en-dm.json": [
		37308,
		49576
	],
	"./angular-locale_en-er.json": [
		72052,
		59148
	],
	"./angular-locale_en-fi.json": [
		57258,
		52550
	],
	"./angular-locale_en-fj.json": [
		6747,
		4395
	],
	"./angular-locale_en-fk.json": [
		72856,
		47656
	],
	"./angular-locale_en-fm.json": [
		59590,
		86802
	],
	"./angular-locale_en-gb.json": [
		76034,
		29890
	],
	"./angular-locale_en-gd.json": [
		44588,
		45400
	],
	"./angular-locale_en-gg.json": [
		62233,
		55529
	],
	"./angular-locale_en-gh.json": [
		96776,
		41180
	],
	"./angular-locale_en-gi.json": [
		98187,
		47055
	],
	"./angular-locale_en-gm.json": [
		25239,
		12323
	],
	"./angular-locale_en-gu.json": [
		50287,
		1739
	],
	"./angular-locale_en-gy.json": [
		41083,
		95391
	],
	"./angular-locale_en-hk.json": [
		71630,
		72518
	],
	"./angular-locale_en-ie.json": [
		76057,
		57709
	],
	"./angular-locale_en-il.json": [
		43222,
		16066
	],
	"./angular-locale_en-im.json": [
		67217,
		7493
	],
	"./angular-locale_en-in.json": [
		20868,
		54068
	],
	"./angular-locale_en-io.json": [
		73239,
		27303
	],
	"./angular-locale_en-iso.json": [
		14508,
		97882
	],
	"./angular-locale_en-je.json": [
		89522,
		22918
	],
	"./angular-locale_en-jm.json": [
		36586,
		99342
	],
	"./angular-locale_en-jp.json": [
		49753,
		73157
	],
	"./angular-locale_en-ke.json": [
		63219,
		13255
	],
	"./angular-locale_en-ki.json": [
		35319,
		11299
	],
	"./angular-locale_en-kn.json": [
		22842,
		85002
	],
	"./angular-locale_en-ky.json": [
		90215,
		8211
	],
	"./angular-locale_en-lc.json": [
		98818,
		90754
	],
	"./angular-locale_en-lr.json": [
		3421,
		21717
	],
	"./angular-locale_en-ls.json": [
		39589,
		59250
	],
	"./angular-locale_en-mg.json": [
		43107,
		42507
	],
	"./angular-locale_en-mh.json": [
		21478,
		75706
	],
	"./angular-locale_en-mo.json": [
		68635,
		35763
	],
	"./angular-locale_en-mp.json": [
		1950,
		56418
	],
	"./angular-locale_en-ms.json": [
		9279,
		40807
	],
	"./angular-locale_en-mt.json": [
		3586,
		21686
	],
	"./angular-locale_en-mu.json": [
		43021,
		61225
	],
	"./angular-locale_en-mw.json": [
		37843,
		21531
	],
	"./angular-locale_en-my.json": [
		18641,
		97741
	],
	"./angular-locale_en-na.json": [
		19562,
		11574
	],
	"./angular-locale_en-nf.json": [
		76551,
		72167
	],
	"./angular-locale_en-ng.json": [
		28244,
		79700
	],
	"./angular-locale_en-nl.json": [
		87145,
		86349
	],
	"./angular-locale_en-no.json": [
		51132,
		79292
	],
	"./angular-locale_en-nr.json": [
		9931,
		39851
	],
	"./angular-locale_en-nu.json": [
		41142,
		31154
	],
	"./angular-locale_en-nz.json": [
		11859,
		41779
	],
	"./angular-locale_en-pg.json": [
		47490,
		42082
	],
	"./angular-locale_en-ph.json": [
		22103,
		24515
	],
	"./angular-locale_en-pk.json": [
		7414,
		40446
	],
	"./angular-locale_en-pn.json": [
		84005,
		83405
	],
	"./angular-locale_en-pr.json": [
		48969,
		38905
	],
	"./angular-locale_en-pw.json": [
		10642,
		10578
	],
	"./angular-locale_en-rw.json": [
		66088,
		64928
	],
	"./angular-locale_en-sb.json": [
		24150,
		50430
	],
	"./angular-locale_en-sc.json": [
		24081,
		3185
	],
	"./angular-locale_en-sd.json": [
		424,
		34684
	],
	"./angular-locale_en-se.json": [
		92939,
		81903
	],
	"./angular-locale_en-sg.json": [
		86341,
		27565
	],
	"./angular-locale_en-sh.json": [
		77580,
		55352
	],
	"./angular-locale_en-si.json": [
		86591,
		47803
	],
	"./angular-locale_en-sl.json": [
		84963,
		46036
	],
	"./angular-locale_en-ss.json": [
		35169,
		90977
	],
	"./angular-locale_en-sx.json": [
		34140,
		60616
	],
	"./angular-locale_en-sz.json": [
		83790,
		58182
	],
	"./angular-locale_en-tc.json": [
		87770,
		77418
	],
	"./angular-locale_en-tk.json": [
		4290,
		5058
	],
	"./angular-locale_en-to.json": [
		7262,
		81718
	],
	"./angular-locale_en-tt.json": [
		97671,
		7699
	],
	"./angular-locale_en-tv.json": [
		73281,
		52865
	],
	"./angular-locale_en-tz.json": [
		42141,
		79093
	],
	"./angular-locale_en-ug.json": [
		11803,
		73363
	],
	"./angular-locale_en-um.json": [
		21501,
		95289
	],
	"./angular-locale_en-us-posix.json": [
		86897,
		90733
	],
	"./angular-locale_en-us.json": [
		42039
	],
	"./angular-locale_en-vc.json": [
		65008,
		89280
	],
	"./angular-locale_en-vg.json": [
		88268,
		73820
	],
	"./angular-locale_en-vi.json": [
		26554,
		87254
	],
	"./angular-locale_en-vu.json": [
		9102,
		12762
	],
	"./angular-locale_en-ws.json": [
		99885,
		70021
	],
	"./angular-locale_en-xa.json": [
		94756,
		37376
	],
	"./angular-locale_en-za.json": [
		31038,
		81282
	],
	"./angular-locale_en-zm.json": [
		11546,
		88542
	],
	"./angular-locale_en-zw.json": [
		27840,
		98728
	],
	"./angular-locale_en.json": [
		38152,
		41474
	],
	"./angular-locale_eo-001.json": [
		54213,
		91919
	],
	"./angular-locale_eo.json": [
		39563,
		32901
	],
	"./angular-locale_es-419.json": [
		89060,
		9774
	],
	"./angular-locale_es-ar.json": [
		15545,
		61393
	],
	"./angular-locale_es-bo.json": [
		48701,
		71533
	],
	"./angular-locale_es-br.json": [
		68822,
		71078
	],
	"./angular-locale_es-bz.json": [
		13822,
		47502
	],
	"./angular-locale_es-cl.json": [
		70701,
		19137
	],
	"./angular-locale_es-co.json": [
		15184,
		35344
	],
	"./angular-locale_es-cr.json": [
		92519,
		98791
	],
	"./angular-locale_es-cu.json": [
		30474,
		64342
	],
	"./angular-locale_es-do.json": [
		11987,
		38291
	],
	"./angular-locale_es-ea.json": [
		37368,
		13428
	],
	"./angular-locale_es-ec.json": [
		85354,
		91778
	],
	"./angular-locale_es-es.json": [
		32442,
		78226
	],
	"./angular-locale_es-gq.json": [
		81666,
		38822
	],
	"./angular-locale_es-gt.json": [
		7513,
		35541
	],
	"./angular-locale_es-hn.json": [
		57412,
		55004
	],
	"./angular-locale_es-ic.json": [
		76710,
		66374
	],
	"./angular-locale_es-mx.json": [
		2939,
		22567
	],
	"./angular-locale_es-ni.json": [
		40211,
		88975
	],
	"./angular-locale_es-pa.json": [
		71493,
		84353
	],
	"./angular-locale_es-pe.json": [
		9233,
		44477
	],
	"./angular-locale_es-ph.json": [
		8578,
		28262
	],
	"./angular-locale_es-pr.json": [
		44184,
		18784
	],
	"./angular-locale_es-py.json": [
		11069,
		98825
	],
	"./angular-locale_es-sv.json": [
		85195,
		77451
	],
	"./angular-locale_es-us.json": [
		51050,
		16802
	],
	"./angular-locale_es-uy.json": [
		26208,
		28092
	],
	"./angular-locale_es-ve.json": [
		91023,
		45715
	],
	"./angular-locale_es.json": [
		8015,
		15905
	],
	"./angular-locale_et-ee.json": [
		10379,
		31959
	],
	"./angular-locale_et.json": [
		85906,
		49708
	],
	"./angular-locale_eu-es.json": [
		76144,
		19408
	],
	"./angular-locale_eu.json": [
		27357,
		42175
	],
	"./angular-locale_ewo-cm.json": [
		54191,
		77049
	],
	"./angular-locale_ewo.json": [
		26220,
		77924
	],
	"./angular-locale_fa-af.json": [
		15830,
		74386
	],
	"./angular-locale_fa-ir.json": [
		32658,
		18350
	],
	"./angular-locale_ff-cm.json": [
		1434,
		8602
	],
	"./angular-locale_ff-gn.json": [
		70943,
		9699
	],
	"./angular-locale_ff-mr.json": [
		87445,
		30969
	],
	"./angular-locale_ff-sn.json": [
		81627,
		60879
	],
	"./angular-locale_ff.json": [
		67159,
		35237
	],
	"./angular-locale_fi-fi.json": [
		20532,
		70980
	],
	"./angular-locale_fi.json": [
		96994,
		55360
	],
	"./angular-locale_fil-ph.json": [
		23773,
		65419
	],
	"./angular-locale_fil.json": [
		3114,
		98522
	],
	"./angular-locale_fo-dk.json": [
		3166,
		17066
	],
	"./angular-locale_fo-fo.json": [
		21800,
		49468
	],
	"./angular-locale_fo.json": [
		8396,
		80490
	],
	"./angular-locale_fr-be.json": [
		4303,
		18591
	],
	"./angular-locale_fr-bf.json": [
		53230,
		98874
	],
	"./angular-locale_fr-bi.json": [
		90267,
		24939
	],
	"./angular-locale_fr-bj.json": [
		26378,
		44806
	],
	"./angular-locale_fr-bl.json": [
		23764,
		64356
	],
	"./angular-locale_fr-ca.json": [
		82754,
		74506
	],
	"./angular-locale_fr-cd.json": [
		60185,
		66993
	],
	"./angular-locale_fr-cf.json": [
		19519,
		69859
	],
	"./angular-locale_fr-cg.json": [
		94156,
		33024
	],
	"./angular-locale_fr-ch.json": [
		19269,
		29253
	],
	"./angular-locale_fr-ci.json": [
		82586,
		87426
	],
	"./angular-locale_fr-cm.json": [
		57078,
		30998
	],
	"./angular-locale_fr-dj.json": [
		53584,
		41684
	],
	"./angular-locale_fr-dz.json": [
		76992,
		66436
	],
	"./angular-locale_fr-fr.json": [
		64966,
		49490
	],
	"./angular-locale_fr-ga.json": [
		8249,
		60238
	],
	"./angular-locale_fr-gf.json": [
		83816,
		78559
	],
	"./angular-locale_fr-gn.json": [
		52259,
		38423
	],
	"./angular-locale_fr-gp.json": [
		27793,
		64497
	],
	"./angular-locale_fr-gq.json": [
		61654,
		11742
	],
	"./angular-locale_fr-ht.json": [
		31090,
		71322
	],
	"./angular-locale_fr-km.json": [
		66622,
		1870
	],
	"./angular-locale_fr-lu.json": [
		60825,
		63625
	],
	"./angular-locale_fr-ma.json": [
		79076,
		79796
	],
	"./angular-locale_fr-mc.json": [
		13430,
		76930
	],
	"./angular-locale_fr-mf.json": [
		90021,
		97961
	],
	"./angular-locale_fr-mg.json": [
		15642,
		69942
	],
	"./angular-locale_fr-ml.json": [
		56019,
		29635
	],
	"./angular-locale_fr-mq.json": [
		4980,
		4548
	],
	"./angular-locale_fr-mr.json": [
		73025,
		50965
	],
	"./angular-locale_fr-mu.json": [
		8792,
		10728
	],
	"./angular-locale_fr-nc.json": [
		92521,
		89613
	],
	"./angular-locale_fr-ne.json": [
		79971,
		30723
	],
	"./angular-locale_fr-pf.json": [
		8360,
		21540
	],
	"./angular-locale_fr-pm.json": [
		30957,
		48829
	],
	"./angular-locale_fr-re.json": [
		37759,
		22127
	],
	"./angular-locale_fr-rw.json": [
		16873,
		50077
	],
	"./angular-locale_fr-sc.json": [
		66432,
		44364
	],
	"./angular-locale_fr-sn.json": [
		10567,
		47627
	],
	"./angular-locale_fr-sy.json": [
		43194,
		36130
	],
	"./angular-locale_fr-td.json": [
		57286,
		43406
	],
	"./angular-locale_fr-tg.json": [
		9479,
		6515
	],
	"./angular-locale_fr-tn.json": [
		84060,
		56520
	],
	"./angular-locale_fr-vu.json": [
		79851,
		96027
	],
	"./angular-locale_fr-wf.json": [
		77195,
		55919
	],
	"./angular-locale_fr-yt.json": [
		89967,
		25631
	],
	"./angular-locale_fr.json": [
		71099,
		21305
	],
	"./angular-locale_fur-it.json": [
		58686,
		3536
	],
	"./angular-locale_fur.json": [
		20152,
		4052
	],
	"./angular-locale_fy-nl.json": [
		11283,
		86259
	],
	"./angular-locale_fy.json": [
		83442,
		24336
	],
	"./angular-locale_ga-ie.json": [
		30972,
		64716
	],
	"./angular-locale_ga.json": [
		4507,
		86969
	],
	"./angular-locale_gd-gb.json": [
		71862,
		90962
	],
	"./angular-locale_gd.json": [
		38004,
		22226
	],
	"./angular-locale_gl-es.json": [
		7011,
		90839
	],
	"./angular-locale_gl.json": [
		26652,
		21210
	],
	"./angular-locale_gsw-ch.json": [
		17746,
		52496
	],
	"./angular-locale_gsw-fr.json": [
		94725,
		23675
	],
	"./angular-locale_gsw-li.json": [
		57202,
		79988
	],
	"./angular-locale_gsw.json": [
		86742,
		26362
	],
	"./angular-locale_gu-in.json": [
		28453,
		46057
	],
	"./angular-locale_gu.json": [
		34743,
		901
	],
	"./angular-locale_guz-ke.json": [
		44754,
		35128
	],
	"./angular-locale_guz.json": [
		85327,
		87939
	],
	"./angular-locale_gv-im.json": [
		86379,
		61979
	],
	"./angular-locale_gv.json": [
		88374,
		70772
	],
	"./angular-locale_ha-gh.json": [
		32756,
		11096
	],
	"./angular-locale_ha-ne.json": [
		75114,
		42198
	],
	"./angular-locale_ha-ng.json": [
		81451,
		49208
	],
	"./angular-locale_ha.json": [
		80844,
		70534
	],
	"./angular-locale_haw-us.json": [
		90304,
		88526
	],
	"./angular-locale_haw.json": [
		9597,
		67637
	],
	"./angular-locale_he-il.json": [
		61182,
		34258
	],
	"./angular-locale_he.json": [
		10608,
		4786
	],
	"./angular-locale_hi-in.json": [
		65816,
		46696
	],
	"./angular-locale_hi.json": [
		58884,
		52526
	],
	"./angular-locale_hr-ba.json": [
		68753,
		44389
	],
	"./angular-locale_hr-hr.json": [
		51114,
		64066
	],
	"./angular-locale_hr.json": [
		89769,
		85051
	],
	"./angular-locale_hsb-de.json": [
		1132,
		19050
	],
	"./angular-locale_hsb.json": [
		46688,
		96176
	],
	"./angular-locale_hu-hu.json": [
		48464,
		60444
	],
	"./angular-locale_hu.json": [
		69216,
		36290
	],
	"./angular-locale_hy-am.json": [
		20701,
		92225
	],
	"./angular-locale_hy.json": [
		30868,
		34654
	],
	"./angular-locale_id-id.json": [
		55504,
		53764
	],
	"./angular-locale_id.json": [
		60822,
		62448
	],
	"./angular-locale_ig-ng.json": [
		32649,
		31753
	],
	"./angular-locale_ig.json": [
		7191,
		22177
	],
	"./angular-locale_ii-cn.json": [
		80453,
		62901
	],
	"./angular-locale_ii.json": [
		93869,
		46775
	],
	"./angular-locale_in.json": [
		19084,
		23238
	],
	"./angular-locale_is-is.json": [
		70754,
		52690
	],
	"./angular-locale_is.json": [
		76955,
		66221
	],
	"./angular-locale_it-ch.json": [
		58882,
		63486
	],
	"./angular-locale_it-it.json": [
		3600,
		50244
	],
	"./angular-locale_it-sm.json": [
		23305,
		95037
	],
	"./angular-locale_it-va.json": [
		4024,
		49756
	],
	"./angular-locale_it.json": [
		99174,
		93472
	],
	"./angular-locale_iw.json": [
		42535,
		11089
	],
	"./angular-locale_ja-jp.json": [
		98759,
		9671
	],
	"./angular-locale_ja.json": [
		35686,
		34756
	],
	"./angular-locale_jgo-cm.json": [
		83460,
		43730
	],
	"./angular-locale_jgo.json": [
		21665,
		78925
	],
	"./angular-locale_jmc-tz.json": [
		90300,
		25454
	],
	"./angular-locale_jmc.json": [
		46879,
		4091
	],
	"./angular-locale_ka-ge.json": [
		10006,
		20118
	],
	"./angular-locale_ka.json": [
		52919,
		81509
	],
	"./angular-locale_kab-dz.json": [
		81300,
		74478
	],
	"./angular-locale_kab.json": [
		68759,
		61771
	],
	"./angular-locale_kam-ke.json": [
		2717,
		33327
	],
	"./angular-locale_kam.json": [
		98594,
		44442
	],
	"./angular-locale_kde-tz.json": [
		8732,
		9250
	],
	"./angular-locale_kde.json": [
		2271,
		35095
	],
	"./angular-locale_kea-cv.json": [
		7899,
		92362
	],
	"./angular-locale_kea.json": [
		25074,
		54178
	],
	"./angular-locale_khq-ml.json": [
		89047,
		47301
	],
	"./angular-locale_khq.json": [
		16367,
		60583
	],
	"./angular-locale_ki-ke.json": [
		36386,
		76322
	],
	"./angular-locale_ki.json": [
		671,
		11949
	],
	"./angular-locale_kk-kz.json": [
		53381,
		9897
	],
	"./angular-locale_kk.json": [
		18041,
		93135
	],
	"./angular-locale_kkj-cm.json": [
		27132,
		79418
	],
	"./angular-locale_kkj.json": [
		30121,
		19781
	],
	"./angular-locale_kl-gl.json": [
		252,
		6876
	],
	"./angular-locale_kl.json": [
		40272,
		68990
	],
	"./angular-locale_kln-ke.json": [
		63665,
		12071
	],
	"./angular-locale_kln.json": [
		44926,
		93685
	],
	"./angular-locale_km-kh.json": [
		12197,
		92629
	],
	"./angular-locale_km.json": [
		3200,
		2897
	],
	"./angular-locale_kn-in.json": [
		64190,
		78698
	],
	"./angular-locale_kn.json": [
		78306,
		95392
	],
	"./angular-locale_ko-kp.json": [
		72967,
		79543
	],
	"./angular-locale_ko-kr.json": [
		62977,
		95573
	],
	"./angular-locale_ko.json": [
		65037,
		53059
	],
	"./angular-locale_kok-in.json": [
		84054,
		99224
	],
	"./angular-locale_kok.json": [
		20858,
		94654
	],
	"./angular-locale_ks-in.json": [
		77607,
		2139
	],
	"./angular-locale_ks.json": [
		97825,
		48695
	],
	"./angular-locale_ksb-tz.json": [
		22238,
		85960
	],
	"./angular-locale_ksb.json": [
		22169,
		31781
	],
	"./angular-locale_ksf-cm.json": [
		17576,
		67398
	],
	"./angular-locale_ksf.json": [
		6029,
		96745
	],
	"./angular-locale_ksh-de.json": [
		57101,
		39035
	],
	"./angular-locale_ksh.json": [
		19351,
		47
	],
	"./angular-locale_kw-gb.json": [
		54093,
		43585
	],
	"./angular-locale_kw.json": [
		11605,
		56715
	],
	"./angular-locale_ky-kg.json": [
		80576,
		25860
	],
	"./angular-locale_ky.json": [
		35439,
		21085
	],
	"./angular-locale_lag-tz.json": [
		75966,
		70028
	],
	"./angular-locale_lag.json": [
		87577,
		44289
	],
	"./angular-locale_lb-lu.json": [
		27807,
		49915
	],
	"./angular-locale_lb.json": [
		52933,
		90823
	],
	"./angular-locale_lg-ug.json": [
		65385,
		37201
	],
	"./angular-locale_lg.json": [
		76342,
		60920
	],
	"./angular-locale_lkt-us.json": [
		88161,
		64323
	],
	"./angular-locale_lkt.json": [
		91746,
		55646
	],
	"./angular-locale_ln-ao.json": [
		77732,
		91844
	],
	"./angular-locale_ln-cd.json": [
		23575,
		75347
	],
	"./angular-locale_ln-cf.json": [
		11806,
		68929
	],
	"./angular-locale_ln-cg.json": [
		23286,
		28462
	],
	"./angular-locale_ln.json": [
		56153,
		62019
	],
	"./angular-locale_lo-la.json": [
		56482,
		94230
	],
	"./angular-locale_lo.json": [
		51966,
		55936
	],
	"./angular-locale_lrc-iq.json": [
		77155,
		82657
	],
	"./angular-locale_lrc-ir.json": [
		6130,
		98864
	],
	"./angular-locale_lrc.json": [
		20570,
		7042
	],
	"./angular-locale_lt-lt.json": [
		23754,
		4534
	],
	"./angular-locale_lt.json": [
		45927,
		7481
	],
	"./angular-locale_lu-cd.json": [
		82492,
		66184
	],
	"./angular-locale_lu.json": [
		67892,
		37126
	],
	"./angular-locale_luo-ke.json": [
		8328,
		57634
	],
	"./angular-locale_luo.json": [
		18957,
		29549
	],
	"./angular-locale_luy-ke.json": [
		37778,
		42632
	],
	"./angular-locale_luy.json": [
		53775,
		47795
	],
	"./angular-locale_lv-lv.json": [
		83898,
		37130
	],
	"./angular-locale_lv.json": [
		35937,
		91083
	],
	"./angular-locale_mas-ke.json": [
		46337,
		16987
	],
	"./angular-locale_mas-tz.json": [
		32355,
		10585
	],
	"./angular-locale_mas.json": [
		9358,
		59742
	],
	"./angular-locale_mer-ke.json": [
		9408,
		72730
	],
	"./angular-locale_mer.json": [
		48757,
		82037
	],
	"./angular-locale_mfe-mu.json": [
		81692,
		81142
	],
	"./angular-locale_mfe.json": [
		27516,
		78147
	],
	"./angular-locale_mg-mg.json": [
		48890,
		42706
	],
	"./angular-locale_mg.json": [
		86235,
		33461
	],
	"./angular-locale_mgh-mz.json": [
		24955,
		54229
	],
	"./angular-locale_mgh.json": [
		67461,
		38097
	],
	"./angular-locale_mgo-cm.json": [
		887,
		3937
	],
	"./angular-locale_mgo.json": [
		36471,
		93116
	],
	"./angular-locale_mk-mk.json": [
		55546,
		56850
	],
	"./angular-locale_mk.json": [
		11791,
		19681
	],
	"./angular-locale_ml-in.json": [
		14222,
		90510
	],
	"./angular-locale_ml.json": [
		89682,
		53484
	],
	"./angular-locale_mn-mn.json": [
		51376,
		52936
	],
	"./angular-locale_mn.json": [
		69376,
		45082
	],
	"./angular-locale_mo.json": [
		77059,
		4765
	],
	"./angular-locale_mr-in.json": [
		94584,
		65520
	],
	"./angular-locale_mr.json": [
		1796,
		19574
	],
	"./angular-locale_ms-bn.json": [
		47082,
		65186
	],
	"./angular-locale_ms-my.json": [
		95808,
		99068
	],
	"./angular-locale_ms-sg.json": [
		3488,
		98592
	],
	"./angular-locale_ms.json": [
		86743,
		1641
	],
	"./angular-locale_mt-mt.json": [
		90792,
		89060
	],
	"./angular-locale_mt.json": [
		40474,
		83252
	],
	"./angular-locale_mua-cm.json": [
		755,
		5625
	],
	"./angular-locale_mua.json": [
		92728,
		80900
	],
	"./angular-locale_my-mm.json": [
		52218,
		32590
	],
	"./angular-locale_my.json": [
		23737,
		27683
	],
	"./angular-locale_mzn-ir.json": [
		12402,
		60144
	],
	"./angular-locale_mzn.json": [
		57690,
		30690
	],
	"./angular-locale_naq-na.json": [
		99325,
		13471
	],
	"./angular-locale_naq.json": [
		23673,
		42473
	],
	"./angular-locale_nb-no.json": [
		43309,
		91585
	],
	"./angular-locale_nb-sj.json": [
		55043,
		69567
	],
	"./angular-locale_nb.json": [
		6131,
		31729
	],
	"./angular-locale_nd-zw.json": [
		34259,
		22191
	],
	"./angular-locale_nd.json": [
		58073,
		10447
	],
	"./angular-locale_nds-de.json": [
		32366,
		26344
	],
	"./angular-locale_nds-nl.json": [
		93943,
		52197
	],
	"./angular-locale_nds.json": [
		42774,
		44602
	],
	"./angular-locale_ne-in.json": [
		6466,
		59710
	],
	"./angular-locale_ne-np.json": [
		21019,
		51707
	],
	"./angular-locale_ne.json": [
		53886,
		63228
	],
	"./angular-locale_nl-aw.json": [
		98036,
		67208
	],
	"./angular-locale_nl-be.json": [
		12813,
		19485
	],
	"./angular-locale_nl-bq.json": [
		33097,
		40945
	],
	"./angular-locale_nl-cw.json": [
		21054,
		88474
	],
	"./angular-locale_nl-nl.json": [
		8657,
		70118
	],
	"./angular-locale_nl-sr.json": [
		98237,
		5233
	],
	"./angular-locale_nl-sx.json": [
		34491,
		45019
	],
	"./angular-locale_nl.json": [
		70577,
		99175
	],
	"./angular-locale_nmg-cm.json": [
		80298,
		27792
	],
	"./angular-locale_nmg.json": [
		46247,
		60795
	],
	"./angular-locale_nn-no.json": [
		80161,
		60485
	],
	"./angular-locale_nn.json": [
		21079,
		79589
	],
	"./angular-locale_nnh-cm.json": [
		37484,
		73454
	],
	"./angular-locale_nnh.json": [
		86790,
		68033
	],
	"./angular-locale_no-no.json": [
		80888,
		42940
	],
	"./angular-locale_no.json": [
		36132,
		71714
	],
	"./angular-locale_nus-ss.json": [
		80680,
		90102
	],
	"./angular-locale_nus.json": [
		56307,
		27231
	],
	"./angular-locale_nyn-ug.json": [
		53491,
		50733
	],
	"./angular-locale_nyn.json": [
		40608,
		20500
	],
	"./angular-locale_om-et.json": [
		74959,
		30383
	],
	"./angular-locale_om-ke.json": [
		16122,
		46650
	],
	"./angular-locale_om.json": [
		44839,
		11413
	],
	"./angular-locale_or-in.json": [
		6590,
		19946
	],
	"./angular-locale_or.json": [
		35106,
		1664
	],
	"./angular-locale_os-ge.json": [
		12586,
		21092
	],
	"./angular-locale_os-ru.json": [
		48785,
		62673
	],
	"./angular-locale_os.json": [
		31789,
		73731
	],
	"./angular-locale_pa-arab-pk.json": [
		70811,
		29413
	],
	"./angular-locale_pa-arab.json": [
		99847,
		19963
	],
	"./angular-locale_pa-guru-in.json": [
		38570,
		2036
	],
	"./angular-locale_pa-guru.json": [
		27430,
		21442
	],
	"./angular-locale_pa.json": [
		17620,
		80302
	],
	"./angular-locale_pl-pl.json": [
		89914,
		70718
	],
	"./angular-locale_pl.json": [
		96304,
		917
	],
	"./angular-locale_prg-001.json": [
		92128,
		48480
	],
	"./angular-locale_prg.json": [
		83749,
		65794
	],
	"./angular-locale_ps-af.json": [
		18314,
		62906
	],
	"./angular-locale_ps.json": [
		99670,
		31584
	],
	"./angular-locale_pt-ao.json": [
		26158,
		67206
	],
	"./angular-locale_pt-br.json": [
		10450,
		8402
	],
	"./angular-locale_pt-ch.json": [
		24245,
		87961
	],
	"./angular-locale_pt-cv.json": [
		6367,
		36111
	],
	"./angular-locale_pt-gq.json": [
		8742,
		14202
	],
	"./angular-locale_pt-gw.json": [
		22008,
		88656
	],
	"./angular-locale_pt-lu.json": [
		12457,
		17661
	],
	"./angular-locale_pt-mo.json": [
		70546,
		2066
	],
	"./angular-locale_pt-mz.json": [
		4601,
		64553
	],
	"./angular-locale_pt-pt.json": [
		8122,
		71326
	],
	"./angular-locale_pt-st.json": [
		99241,
		30877
	],
	"./angular-locale_pt-tl.json": [
		59070,
		65690
	],
	"./angular-locale_pt.json": [
		56555,
		4333
	],
	"./angular-locale_qu-bo.json": [
		62707,
		72211
	],
	"./angular-locale_qu-ec.json": [
		57028,
		32868
	],
	"./angular-locale_qu-pe.json": [
		37807,
		95987
	],
	"./angular-locale_qu.json": [
		44809,
		363
	],
	"./angular-locale_rm-ch.json": [
		53462,
		10102
	],
	"./angular-locale_rm.json": [
		84714,
		38088
	],
	"./angular-locale_rn-bi.json": [
		70299,
		12939
	],
	"./angular-locale_rn.json": [
		22427,
		5561
	],
	"./angular-locale_ro-md.json": [
		95106,
		53594
	],
	"./angular-locale_ro-ro.json": [
		25712,
		40260
	],
	"./angular-locale_ro.json": [
		36728,
		42982
	],
	"./angular-locale_rof-tz.json": [
		22467,
		24405
	],
	"./angular-locale_rof.json": [
		14862,
		46402
	],
	"./angular-locale_ru-by.json": [
		48080,
		91296
	],
	"./angular-locale_ru-kg.json": [
		42979,
		95151
	],
	"./angular-locale_ru-kz.json": [
		67716,
		57512
	],
	"./angular-locale_ru-md.json": [
		83811,
		96160
	],
	"./angular-locale_ru-ru.json": [
		49236,
		88772
	],
	"./angular-locale_ru-ua.json": [
		19863,
		36535
	],
	"./angular-locale_ru.json": [
		31970,
		33504
	],
	"./angular-locale_rw-rw.json": [
		81680,
		40596
	],
	"./angular-locale_rw.json": [
		89488,
		7102
	],
	"./angular-locale_rwk-tz.json": [
		36010,
		75044
	],
	"./angular-locale_rwk.json": [
		6285,
		9641
	],
	"./angular-locale_sah-ru.json": [
		32029,
		61391
	],
	"./angular-locale_sah.json": [
		13729,
		92073
	],
	"./angular-locale_saq-ke.json": [
		90321,
		16075
	],
	"./angular-locale_saq.json": [
		92894,
		69646
	],
	"./angular-locale_sbp-tz.json": [
		69231,
		1261
	],
	"./angular-locale_sbp.json": [
		69266,
		49482
	],
	"./angular-locale_se-fi.json": [
		88615,
		42999
	],
	"./angular-locale_se-no.json": [
		47117,
		84737
	],
	"./angular-locale_se-se.json": [
		69414,
		15430
	],
	"./angular-locale_se.json": [
		11347,
		83537
	],
	"./angular-locale_seh-mz.json": [
		58675,
		45297
	],
	"./angular-locale_seh.json": [
		80125,
		57013
	],
	"./angular-locale_ses-ml.json": [
		95645,
		20196
	],
	"./angular-locale_ses.json": [
		48392,
		37020
	],
	"./angular-locale_sg-cf.json": [
		45229,
		49121
	],
	"./angular-locale_sg.json": [
		79341,
		86403
	],
	"./angular-locale_sh.json": [
		72100,
		3970
	],
	"./angular-locale_shi-latn-ma.json": [
		13608,
		16120
	],
	"./angular-locale_shi-latn.json": [
		98871,
		92325
	],
	"./angular-locale_shi-tfng-ma.json": [
		70715,
		70300
	],
	"./angular-locale_shi-tfng.json": [
		28599,
		74513
	],
	"./angular-locale_shi.json": [
		23247,
		81015
	],
	"./angular-locale_si-lk.json": [
		57167,
		147
	],
	"./angular-locale_si.json": [
		52823,
		62149
	],
	"./angular-locale_sk-sk.json": [
		65050,
		99206
	],
	"./angular-locale_sk.json": [
		40561,
		8135
	],
	"./angular-locale_sl-si.json": [
		86015,
		70175
	],
	"./angular-locale_sl.json": [
		16904,
		63894
	],
	"./angular-locale_smn-fi.json": [
		50835,
		34865
	],
	"./angular-locale_smn.json": [
		94407,
		40387
	],
	"./angular-locale_sn-zw.json": [
		76742,
		52194
	],
	"./angular-locale_sn.json": [
		66138,
		35832
	],
	"./angular-locale_so-dj.json": [
		78226,
		96430
	],
	"./angular-locale_so-et.json": [
		24481,
		99577
	],
	"./angular-locale_so-ke.json": [
		23024,
		63072
	],
	"./angular-locale_so-so.json": [
		80658,
		82846
	],
	"./angular-locale_so.json": [
		2821,
		11931
	],
	"./angular-locale_sq-al.json": [
		61339,
		69275
	],
	"./angular-locale_sq-mk.json": [
		32474,
		41910
	],
	"./angular-locale_sq-xk.json": [
		99451,
		75679
	],
	"./angular-locale_sq.json": [
		30511,
		79837
	],
	"./angular-locale_sr-cyrl-ba.json": [
		37207,
		74825
	],
	"./angular-locale_sr-cyrl-me.json": [
		36623,
		48674
	],
	"./angular-locale_sr-cyrl-rs.json": [
		28625,
		51419
	],
	"./angular-locale_sr-cyrl-xk.json": [
		75179,
		20417
	],
	"./angular-locale_sr-cyrl.json": [
		85439,
		44303
	],
	"./angular-locale_sr-latn-ba.json": [
		74230,
		59020
	],
	"./angular-locale_sr-latn-me.json": [
		13373,
		74887
	],
	"./angular-locale_sr-latn-rs.json": [
		42820,
		39898
	],
	"./angular-locale_sr-latn-xk.json": [
		54878,
		63312
	],
	"./angular-locale_sr-latn.json": [
		45032,
		42868
	],
	"./angular-locale_sr.json": [
		270,
		19532
	],
	"./angular-locale_sv-ax.json": [
		27208,
		21160
	],
	"./angular-locale_sv-fi.json": [
		71716,
		60628
	],
	"./angular-locale_sv-se.json": [
		72101,
		44741
	],
	"./angular-locale_sv.json": [
		69106,
		34896
	],
	"./angular-locale_sw-cd.json": [
		79267,
		75491
	],
	"./angular-locale_sw-ke.json": [
		38680,
		40904
	],
	"./angular-locale_sw-tz.json": [
		8058,
		1814
	],
	"./angular-locale_sw-ug.json": [
		97196,
		95648
	],
	"./angular-locale_sw.json": [
		20509,
		94099
	],
	"./angular-locale_ta-in.json": [
		90892,
		41404
	],
	"./angular-locale_ta-lk.json": [
		82882,
		16370
	],
	"./angular-locale_ta-my.json": [
		23545,
		28277
	],
	"./angular-locale_ta-sg.json": [
		52429,
		94978
	],
	"./angular-locale_ta.json": [
		61936,
		37322
	],
	"./angular-locale_te-in.json": [
		70336,
		88440
	],
	"./angular-locale_te.json": [
		32172,
		79550
	],
	"./angular-locale_teo-ke.json": [
		70928,
		48522
	],
	"./angular-locale_teo-ug.json": [
		58388,
		52922
	],
	"./angular-locale_teo.json": [
		76069,
		92805
	],
	"./angular-locale_th-th.json": [
		83330,
		90614
	],
	"./angular-locale_th.json": [
		47531,
		92069
	],
	"./angular-locale_ti-er.json": [
		63892,
		56364
	],
	"./angular-locale_ti-et.json": [
		96234,
		51470
	],
	"./angular-locale_ti.json": [
		55016,
		81186
	],
	"./angular-locale_tk-tm.json": [
		41338,
		27622
	],
	"./angular-locale_tk.json": [
		4250,
		40980
	],
	"./angular-locale_tl.json": [
		90935,
		85993
	],
	"./angular-locale_to-to.json": [
		97028,
		60316
	],
	"./angular-locale_to.json": [
		95094,
		5272
	],
	"./angular-locale_tr-cy.json": [
		49060,
		80336
	],
	"./angular-locale_tr-tr.json": [
		90850,
		690
	],
	"./angular-locale_tr.json": [
		58621,
		1343
	],
	"./angular-locale_twq-ne.json": [
		86669,
		42467
	],
	"./angular-locale_twq.json": [
		49485,
		38745
	],
	"./angular-locale_tzm-ma.json": [
		33701,
		35023
	],
	"./angular-locale_tzm.json": [
		1612,
		51616
	],
	"./angular-locale_ug-cn.json": [
		99983,
		3527
	],
	"./angular-locale_ug.json": [
		87440,
		97309
	],
	"./angular-locale_uk-ua.json": [
		93216,
		26876
	],
	"./angular-locale_uk.json": [
		93863,
		43673
	],
	"./angular-locale_ur-in.json": [
		73824,
		32696
	],
	"./angular-locale_ur-pk.json": [
		81978,
		76634
	],
	"./angular-locale_ur.json": [
		70412,
		45214
	],
	"./angular-locale_uz-arab-af.json": [
		30725,
		19999
	],
	"./angular-locale_uz-arab.json": [
		22135,
		96483
	],
	"./angular-locale_uz-cyrl-uz.json": [
		88943,
		29513
	],
	"./angular-locale_uz-cyrl.json": [
		43161,
		40869
	],
	"./angular-locale_uz-latn-uz.json": [
		47645,
		21728
	],
	"./angular-locale_uz-latn.json": [
		77446,
		65014
	],
	"./angular-locale_uz.json": [
		89796,
		12118
	],
	"./angular-locale_vai-latn-lr.json": [
		83712,
		88586
	],
	"./angular-locale_vai-latn.json": [
		92465,
		99967
	],
	"./angular-locale_vai-vaii-lr.json": [
		36552,
		93528
	],
	"./angular-locale_vai-vaii.json": [
		91555,
		49989
	],
	"./angular-locale_vai.json": [
		31369,
		34409
	],
	"./angular-locale_vi-vn.json": [
		83733,
		91641
	],
	"./angular-locale_vi.json": [
		58450,
		39504
	],
	"./angular-locale_vo.json": [
		30012,
		48698
	],
	"./angular-locale_vun-tz.json": [
		51273,
		28587
	],
	"./angular-locale_vun.json": [
		46684,
		5696
	],
	"./angular-locale_wae-ch.json": [
		69818,
		77916
	],
	"./angular-locale_wae.json": [
		53390,
		1046
	],
	"./angular-locale_xog-ug.json": [
		61874,
		27648
	],
	"./angular-locale_xog.json": [
		52123,
		43507
	],
	"./angular-locale_yav-cm.json": [
		33828,
		88622
	],
	"./angular-locale_yav.json": [
		5281,
		16865
	],
	"./angular-locale_yi-001.json": [
		54983,
		38561
	],
	"./angular-locale_yi.json": [
		82461,
		1383
	],
	"./angular-locale_yo-bj.json": [
		35374,
		7190
	],
	"./angular-locale_yo-ng.json": [
		95569,
		72833
	],
	"./angular-locale_yo.json": [
		63119,
		46537
	],
	"./angular-locale_yue-hk.json": [
		70649,
		99600
	],
	"./angular-locale_yue.json": [
		87392,
		4996
	],
	"./angular-locale_zgh-ma.json": [
		67625,
		2015
	],
	"./angular-locale_zgh.json": [
		27816,
		85296
	],
	"./angular-locale_zh-cn.json": [
		41817,
		8029
	],
	"./angular-locale_zh-hans-cn.json": [
		56070,
		66980
	],
	"./angular-locale_zh-hans-hk.json": [
		44650,
		28868
	],
	"./angular-locale_zh-hans-mo.json": [
		38311,
		43841
	],
	"./angular-locale_zh-hans-sg.json": [
		13433,
		7823
	],
	"./angular-locale_zh-hans.json": [
		2964,
		51032
	],
	"./angular-locale_zh-hant-hk.json": [
		67145,
		65380
	],
	"./angular-locale_zh-hant-mo.json": [
		76628,
		36554
	],
	"./angular-locale_zh-hant-tw.json": [
		89105,
		55103
	],
	"./angular-locale_zh-hant.json": [
		48821,
		77349
	],
	"./angular-locale_zh-hk.json": [
		66205,
		44849
	],
	"./angular-locale_zh-tw.json": [
		77445,
		14665
	],
	"./angular-locale_zh.json": [
		9401,
		75599
	],
	"./angular-locale_zu-za.json": [
		32824,
		5944
	],
	"./angular-locale_zu.json": [
		22410,
		9832
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 27774;
module.exports = webpackAsyncContext;